let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k6B8h")).then(() => parcelRequire('CQmJI'));